import React from "react";
import "../style/WhyEvas.scss";
import whyChooseEvas from "../data/whyEvas.json"; // import JSON

const WhyEvas = () => {
  return (
    <section className="WhyEvas">
      <h2 className="title-WhyEvas">Why EVAS</h2>
      <p className="subtitle-WhyEvas">
        Evas provides custom web design, development, SEO, social media management, and creative content. We focus on building fast, user-friendly websites, boosting online presence, and offering ongoing support to help businesses grow and thrive.
      </p>

      <div className="cards-WhyEvas">
        {whyChooseEvas.map((whyChoose, index) => (
          <div className="card-WhyEvas" key={index}>
            <img
              src={whyChoose.icon}
              alt={whyChoose.alt}
              className="logo-WhyEvas"
            />
            <p className="quote-WhyEvas">"{whyChoose.reason}"</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyEvas;